// extracted by mini-css-extract-plugin
module.exports = {"container":"_1pzMY","GuideBgShow":"_2_Fo2","close":"_1JKGZ","main":"_1FeRx","title":"_1dQvy","text":"_2j9cl","mask":"_3dfXs","animate":"KZiO8"};